import {
  createElementVNode as _createElementVNode,
  openBlock as _openBlock,
  createElementBlock as _createElementBlock,
} from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#686C73",
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
      },
      [
        _createElementVNode("path", {
          d: "M5.48543 2.70682V3.81562H0.333328V2.70682H5.48543ZM1.83495 0.666626H3.36245V8.78305C3.36245 9.15265 3.42502 9.42985 3.55016 9.61465C3.67961 9.79575 3.84358 9.91772 4.04207 9.98056C4.24487 10.0397 4.45846 10.0693 4.68284 10.0693C4.85113 10.0693 4.98921 10.0619 5.09708 10.0471C5.20496 10.0286 5.29126 10.0138 5.35598 10.0027L5.66666 11.1781C5.5631 11.2113 5.41855 11.2446 5.233 11.2779C5.04746 11.3148 4.81229 11.3333 4.5275 11.3333C4.096 11.3333 3.67313 11.2538 3.25889 11.0949C2.84897 10.936 2.50809 10.6939 2.23624 10.3686C1.96871 10.0434 1.83495 9.63313 1.83495 9.13787V0.666626Z",
        }),
      ]
    )
  );
}
